module.exports = __webpack_public_path__ + "static/media/pic6.74535aa9.jpg";